import clsx from 'clsx';

const TAG_COLORS = {
    default: { bg: 'rgba(148,163,184,0.15)', color: '#94a3b8' },
    tech: { bg: 'rgba(96,165,250,0.15)', color: '#60a5fa' },
    forensic: { bg: 'rgba(244,114,182,0.15)', color: '#f472b6' },
    surveillance: { bg: 'rgba(251,146,60,0.15)', color: '#fb923c' },
    security: { bg: 'rgba(248,113,113,0.15)', color: '#f87171' },
    hardware: { bg: 'rgba(167,139,250,0.15)', color: '#a78bfa' },
    software: { bg: 'rgba(52,211,153,0.15)', color: '#34d399' },
    compliance: { bg: 'rgba(251,191,36,0.15)', color: '#fbbf24' },
    vendor: { bg: 'rgba(212,175,55,0.15)', color: '#d4af37' },
};

function getTagColor(tag) {
    const lower = (tag || '').toLowerCase();
    for (const [key, color] of Object.entries(TAG_COLORS)) {
        if (lower.includes(key)) return color;
    }
    return TAG_COLORS.default;
}

export default function TagChips({ tags }) {
    if (!tags || tags.length === 0) return null;

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
            {tags.map((tag, idx) => {
                // Tags from backend can be strings or objects {display_name, color, slug}
                const tagName = typeof tag === 'string' ? tag : (tag.display_name || tag.name || tag.label || String(tag));
                const customColor = typeof tag === 'object' && tag.color ? tag.color : null;
                const color = customColor ? { bg: customColor + '22', color: customColor } : getTagColor(tagName);
                return (
                    <span
                        key={idx}
                        style={{
                            background: color.bg,
                            color: color.color,
                            padding: '0.2rem 0.6rem',
                            borderRadius: '9999px',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                        }}
                    >
                        {tagName}
                    </span>
                );
            })}
        </div>
    );
}